import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { countries, type CountryCode } from "@shared/schema";

interface SalaryInputProps {
  value: number | string;
  onChange: (value: number) => void;
  countryCode: CountryCode;
  className?: string;
}

export function SalaryInput({ value, onChange, countryCode, className }: SalaryInputProps) {
  const country = countries.find(c => c.code === countryCode);
  const symbol = country?.symbol || "$";

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value.replace(/[^0-9.]/g, "");
    const numValue = parseFloat(rawValue) || 0;
    onChange(numValue);
  };

  const formatValue = (val: number | string) => {
    const num = typeof val === "string" ? parseFloat(val) : val;
    if (isNaN(num) || num === 0) return "";
    return num.toLocaleString("en-US", { maximumFractionDigits: 2 });
  };

  return (
    <div className={`space-y-2 ${className}`}>
      <Label htmlFor="salary-input" className="text-sm font-medium">
        Gross Salary
      </Label>
      <div className="relative w-full overflow-hidden">
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground font-mono text-lg z-10">
          {symbol}
        </span>
        <Input
          id="salary-input"
          type="text"
          inputMode="decimal"
          value={formatValue(value)}
          onChange={handleChange}
          placeholder="0"
          className="pl-10 text-xl font-mono h-14 text-right tabular-nums w-full min-w-0"
          data-testid="input-salary"
        />
      </div>
    </div>
  );
}
